import axios from 'axios';

function mergeConfig(config = {}) {
  return {
    ...config
  };
}

export async function apiGet(url, config) {
  const response = await axios.get(url, mergeConfig(config));
  return response.data;
}

export async function apiPost(url, data, config) {
  const response = await axios.post(url, data, mergeConfig(config));
  return response.data;
}

export async function apiPut(url, data, config) {
  const response = await axios.put(url, data, mergeConfig(config));
  return response.data;
}

export async function apiDelete(url, config) {
  const response = await axios.delete(url, mergeConfig(config));
  return response.data;
}
